export default __webpack_public_path__ + "static/media/wpp.a1c0a1e0.svg";